import { render } from "./viewer.vue?vue&type=template&id=24bca322"
import script from "./viewer.vue?vue&type=script&lang=js"
export * from "./viewer.vue?vue&type=script&lang=js"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "24bca322"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('24bca322', script)) {
    api.reload('24bca322', script)
  }
  
  module.hot.accept("./viewer.vue?vue&type=template&id=24bca322", () => {
    api.rerender('24bca322', render)
  })

}

script.__file = "src/components/viewer.vue"

export default script